// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__eZ6al","requiredAsterisk":"Info_requiredAsterisk__3u59d"};